import { OhsTabKeyTypes } from 'global-components/tab/OhsTabModels';
import { OhsApiRequestName } from 'global-services/api/OhsApiModels';
import { TierType } from 'global-services/constants/OhsObject';
import { OhsUser } from 'user/OhsUser';
import { OhsFormattedParamList } from 'global-services/register/OhsRegisterModels';
import { formatListParamsToPayload } from 'global-services/register/utils';

import {
  GlobalSearchState,
  OhsGlobalSearchPayload,
  OhsModuleSearchPayload,
} from './OhsSearchModels';

const getPayload = (globalSearch: GlobalSearchState, count: boolean) => {
  const { searchInfo, currentPage } = globalSearch;
  const page = currentPage > 10 ? 0 : currentPage;
  const payload = {
    ...globalSearch,
    searchInfo: {
      ...searchInfo,
      filter: {
        ...searchInfo.filter,
        page,
        count,
      },
    },
  };
  return payload;
};

export const getApiReqNameByTab = (tabKey: OhsTabKeyTypes): OhsApiRequestName => {
  switch (tabKey) {
    case OhsTabKeyTypes.Organisation:
      return OhsApiRequestName.OrgList;
    case OhsTabKeyTypes.Workplace:
      return OhsApiRequestName.OrgWorkplaceList;
    default:
      return OhsApiRequestName.List;
  }
};

export const updateSearchInfo = (
  searchInfo: OhsGlobalSearchPayload,
  apiRequestName: OhsApiRequestName,
  user: OhsUser
): OhsGlobalSearchPayload => {
  if (user?.tier.type === TierType.T3 && apiRequestName === OhsApiRequestName.List) {
    return { ...searchInfo, filter: { ...searchInfo.filter, skipAllocatedRecords: true } };
  }
  return searchInfo;
};

// Convert param values to search form
export const formatSearchParamToForm = ({
  params,
  defaultValue,
}: {
  params: URLSearchParams;
  defaultValue: OhsModuleSearchPayload;
}) => {
  const formattedParams: OhsFormattedParamList = formatListParamsToPayload(params, {
    defaultFilter: { ...defaultValue, ...(defaultValue?.filter || {}) },
  });

  const newValues: OhsModuleSearchPayload = {
    ...defaultValue,
    searchKey: formattedParams.searchKey ?? defaultValue.searchKey,
    substringSearch: formattedParams.substringSearch ?? defaultValue.substringSearch,
    filter: {
      ...defaultValue.filter,
      page: formattedParams.page ?? defaultValue.filter.page,
      skipOrgRecords: formattedParams.skipOrgRecords ?? defaultValue.filter.skipOrgRecords,
      skipAllocatedRecords:
        formattedParams.skipAllocatedRecords ?? defaultValue.filter.skipAllocatedRecords,
      archived: formattedParams.archived ?? defaultValue.filter.archived,
      workplaces: formattedParams.workplaces ?? defaultValue.filter.workplaces,
    },
  };

  return newValues;
};

export default getPayload;
